import { FC } from 'react';
import FullscreenButtonStyled from './style';
import { Props } from './types';
import DeviceManager from '../../components/util/deviceManager';
import { FAIcon } from '@packages/ui-components';
const FullscreenButton: FC<Props & { children?: any }> = ({ onClick, isFullscreen }) =>
  !DeviceManager.isMobile() ? (
    <FullscreenButtonStyled onClick={onClick} isFullscreen={isFullscreen}>
      <FAIcon icon={isFullscreen ? 'faCompress' : 'faExpand'} size={16} />
    </FullscreenButtonStyled>
  ) : (
    <></>
  );

export default FullscreenButton;
